import { render, staticRenderFns } from "./normal-radio-block.vue?vue&type=template&id=286297bb&scoped=true&"
import script from "./normal-radio-block.vue?vue&type=script&lang=js&"
export * from "./normal-radio-block.vue?vue&type=script&lang=js&"
import style0 from "./normal-radio-block.vue?vue&type=style&index=0&id=286297bb&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286297bb",
  null
  
)

export default component.exports